import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_contained/home")({
  loader: async () => {
    throw redirect({ to: "/dashboard" });
  },
});
